import styles from './index.module.css'

import { TbSparkles } from '@react-icons/all-files/tb/TbSparkles'
import React from 'react'

import { Button, Switch } from 'components/ds'

type Props = {
  active?: boolean
  onActivate: () => void
  onDeactivate: () => void
}

const AiSearchToggle = ({
  active = false,
  onActivate,
  onDeactivate,
}: Props): React.ReactNode => {
  const handleToggle = () => {
    if (active) onDeactivate()
    else onActivate()
  }

  return (
    <Button
      variant="ghost"
      className={`${styles.btn} ${active ? styles.btnActive : ''}`}
      aria-pressed={active}
      onMouseDown={e => {
        e.preventDefault()
        handleToggle()
      }}
      onClick={e => {
        if (e.detail === 0) handleToggle()
      }}
    >
      <TbSparkles size={11} />
      AI Search
      <Switch
        size="1"
        checked={active}
        className={styles.switch}
        tabIndex={-1}
        aria-hidden
      />
    </Button>
  )
}

export default AiSearchToggle
